import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, BACKEND_URL } from "@/lib/api";

const DEFAULT = {
  logo_main: null, logo_horizontal: null, promo: null, promo_link: "", banners: [], cards: {},
  theme: { primary: "#e5b84a", secondary: "#b88a2e", heading_font: "Lilita One", body_font: "Nunito", button_style: "pill" },
  texts: null, fonts: [],
};
const AppearanceContext = createContext({ ...DEFAULT, reload: () => {} });
const RADIUS = { pill: "999px", rounded: "12px", square: "4px" };

export const siteImg = (url) => (url ? `${BACKEND_URL}${url}` : null);

const loadFonts = (fonts) => {
  const families = [...new Set(fonts)].map((f) => `family=${f.replace(/ /g, "+")}:wght@400;600;700;800;900`).join("&");
  let link = document.getElementById("jp-theme-fonts");
  if (!link) {
    link = document.createElement("link");
    link.id = "jp-theme-fonts";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = `https://fonts.googleapis.com/css2?${families}&display=swap`;
};

export const themeVars = (t) => ({
  "--jp-primary": t.primary,
  "--jp-secondary": t.secondary,
  "--jp-heading-font": `"${t.heading_font}", "Outfit", sans-serif`,
  "--jp-body-font": `"${t.body_font}", "Nunito", sans-serif`,
  "--jp-radius": RADIUS[t.button_style] || "999px",
});

export const AppearanceProvider = ({ children }) => {
  const [data, setData] = useState(DEFAULT);
  const reload = useCallback(async () => {
    try {
      const { data: d } = await api.get("/appearance");
      setData(d);
    } catch {
      setData(DEFAULT);
    }
  }, []);

  useEffect(() => {
    reload();
    const t = setInterval(reload, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [reload]);

  useEffect(() => {
    loadFonts([data.theme.heading_font, data.theme.body_font]);
  }, [data.theme.heading_font, data.theme.body_font]);

  return <AppearanceContext.Provider value={{ ...data, reload }}>{children}</AppearanceContext.Provider>;
};

export const useAppearance = () => useContext(AppearanceContext);
